import {defineStore} from "pinia";
import {computed, Ref, ref} from "vue";
import {EnumDictionary} from "@k/js/delme_globals";

export enum KONFI_DESKTOP_POPUPS {
    PRODUCT_CATEGORIES="PRODUCT_CATEGORIES" ,
    CHOOSE_PRODUCT = "CHOOSE_PRODUCT" ,
    CHOOSE_FEATURES = "CHOOSE_FEATURES",
    PRODUCT_INFO = "PRODUCT_INFO",
    FEATURES_INFO = "FEATURES_INFO",
    TACKLETWILL_INFO = "TACKLETWILL_INFO",
    MAIN_MENU = "MAIN_MENU",
    DESIGN_CHECK = 'DESIGN_CHECK',
    DESIGN_WISH = 'DESIGN_WISH',
    DEBUG_MENU = "DEBUG_MENU",
    OM_MENU = "OM_MENU",
    MUSTER_SERVICE = 'MUSTER_SERVICE',
    ANGEBOT_SERVICE = 'ANGEBOT_SERVICE',
    SIZE_TABLE = 'SIZE_TABLE',
    LIEFER_ZEIT = 'LIEFER_ZEIT',
    EXPRESS_PROD = 'EXPRESS_PROD',
    ANFRAGE = 'ANFRAGE',
    KONTAKT = 'KONTAKT',
    KONTAKT_FORM = 'KONTAKT_FORM',
    ARTIKEL_VIEW = "ARTIKEL_VIEW",
    READY_DESIGNS = "READY_DESIGNS",
    SEND_TO_FRIEND = "SEND_TO_FRIEND"
}
export const KONFI_DESKTOP_POPUPS_RIGHTSIDE = [
    KONFI_DESKTOP_POPUPS.MAIN_MENU,
    KONFI_DESKTOP_POPUPS.PRODUCT_CATEGORIES
] as KONFI_DESKTOP_POPUPS[];


function createOpenStatus():EnumDictionary<KONFI_DESKTOP_POPUPS, boolean> {
    const out = {} as EnumDictionary<KONFI_DESKTOP_POPUPS, boolean>;
    Object.values(KONFI_DESKTOP_POPUPS).forEach(k=>out[k] = false);
    return out;
}

export const useKonfiDesktopPopupStatusStore = defineStore("konfi_desktop_popup_status", ()=> {

    const openStatus = ref(createOpenStatus()) as Ref<EnumDictionary<KONFI_DESKTOP_POPUPS, boolean>>
    return {
        productCategoriesIsVisible:computed(()=>openStatus.value[KONFI_DESKTOP_POPUPS.PRODUCT_CATEGORIES]),
        chooseProductIsVisible:computed(()=>openStatus.value[KONFI_DESKTOP_POPUPS.CHOOSE_PRODUCT]),
        chooseFeaturesIsVisible:computed(()=>openStatus.value[KONFI_DESKTOP_POPUPS.CHOOSE_FEATURES]),
        productInfoOpen:computed(()=>openStatus.value[KONFI_DESKTOP_POPUPS.PRODUCT_INFO]),
        isOpen:computed(()=>openStatus.value),
        openPopup:(popup:KONFI_DESKTOP_POPUPS)=> openStatus.value[popup] = true,

        togglePopup:(popup:KONFI_DESKTOP_POPUPS)=>{
            openStatus.value[popup] = !openStatus.value[popup];
        },
        closePopup:(popup:KONFI_DESKTOP_POPUPS)=>{
            openStatus.value[popup] = false;
        },
        closeAllPopups:()=>{
            Object.values(KONFI_DESKTOP_POPUPS).forEach(k=>openStatus.value[k] = false);
        },
        openLeftSidePopupExclusively:(popupToOpen:KONFI_DESKTOP_POPUPS)=>{
            for(const popup in KONFI_DESKTOP_POPUPS) {
                if(KONFI_DESKTOP_POPUPS_RIGHTSIDE.includes(popup as KONFI_DESKTOP_POPUPS)) {
                    continue;
                }
                openStatus.value[popup] = popup === popupToOpen;
            }
        }
    }
});
